// The current public Vue app, including /__preview/home, runs on this domain.
// Preserve the existing explicit local-development override.
export function getHomepagePreviewConfig() {
  try {
    const url = new URL(localStorage.getItem('homepage_preview_origin') || 'https://mobile.tarekmath.com');
    if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password
      || (window.location.protocol === 'https:' && url.protocol !== 'https:')) {
      throw new Error('Invalid preview origin');
    }
    return { origin: url.origin, url: `${url.origin}/__preview/home` };
  } catch {
    return { origin: null, url: null };
  }
}
